export default import.meta.ROLLDOWN_FILE_URL_Y2Umv5EF9VlBEHBZ0D$Ftg